module.exports = __webpack_public_path__ + "static/media/basic_pencil_ruler.e78188f0.svg";